import { ParseKeys } from 'i18next'
import {
  femaleDays,
  maleDays,
  weekDaysEnumOptions,
} from '~/shared/config/constants'
import { WeekDaysEnum } from '~/shared/config/enums'

export const getDayOffParams = (rentalContractDayOff: string) => {
  const dayOffIndex = Object.keys(WeekDaysEnum).findIndex(
    (key: string) => key === rentalContractDayOff.toUpperCase(),
  )
  const textPrefix: ParseKeys = maleDays.includes(dayOffIndex)
    ? 'day of.every (masculine)'
    : femaleDays.includes(dayOffIndex)
    ? 'day of.every (feminine)'
    : 'day of.every (neuter)'
  const dayOffLabel = weekDaysEnumOptions[dayOffIndex].label
  return { textPrefix, dayOffLabel }
}
